'use strict';

var d3 = require('d3');
var _ = require('lodash');
var ThematicBarChart = function ThematicBarChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartMultiBrush, chartXAxis, chartYAxis, chartYAxisLines, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange', 'rangechangeend');
    d3.rebind(this, dispatch, 'on');
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('d1', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var brush = chartMultiBrush();
    var lines = chartYAxisLines();
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine().withTextRotation(chartConstants.AXIS.SKEW.DEG_40_A).withRepetition(1);
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    function getAdditionalLeftPadding(data) {
      var fittingLabelLength = 6;
      if (!_.isEmpty(data)) {
        var xAxisFirstLabel = formatters.xAxisTickFormatter(data[0].d1);
        if (_.isString(xAxisFirstLabel) && xAxisFirstLabel.length > fittingLabelLength) {
          return Math.floor(4 * (xAxisFirstLabel.length - fittingLabelLength));
        }
      }
      return 0;
    }
    this.render = function (data) {
      this.initChart(data, [0, data.length], chartParams(data.length, getAdditionalLeftPadding(data)));
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([lines, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
      this.callForYAxis(yAxis, this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.withMetric = function (metric) {
      yAxis.label(metric.label);
      return this;
    };
    this.setInitialSelection = function (range, silent) {
      brush.setInitialSelection(range, silent);
    };
    this.getSelection = function () {
      return brush.getSelection();
    };
    brush.on('brushchange', function (range, triggerEnd) {
      this.callForYAxis(yAxis, this.scales);
      this.brushChangeAction(range, groups);
      dispatch.rangechange(range);
      if (triggerEnd) {
        dispatch.rangechangeend(range);
      }
    }.bind(this));
    brush.on('brushend', function (range, silent) {
      dispatch.rangechangeend(range, silent);
    });
    groups.on('groupclick', function (d, i, targetData, event) {
      event.stopPropagation();
      brush.setSelection([i, i + 1]);
      dispatch.rangechangeend(brush.getSelection());
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ThematicBarChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsMultiBrush', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsYAxisLines', 'ChartElementsConstants'];
module.exports = ThematicBarChart;